import {
  ComponentFactoryResolver,
  ComponentRef,
  Injectable,
  Injector,
  ViewContainerRef,
} from '@angular/core';
import { ContentTypeRegistry } from '../services/content-type-registry';
import { SupportedTypes } from '../models/components.enum';

/**
 * The service responsible for the logic related to dynamically resolve
 * a component to be added based on its string content type name.
 *
 * In order to add a new supported item, simply add:
 *
 *  1. The component into the ComponentTypes enum
 *  2. The component into the SupportedTypes
 *  3. The component into the SupportedTypesMap
 */
@Injectable({ providedIn: 'root' })
export class EmbeddedEntryService {
  constructor(
    private registry: ContentTypeRegistry,
    private resolver: ComponentFactoryResolver
  ) {}

  /** Dynamically create the component based its string type name */
  createComponent(
    host: ViewContainerRef,
    type: string,
    injector: Injector
  ): ComponentRef<SupportedTypes | any> | undefined {
    const compType = this.registry.get(type);
    if (compType) {
      const factory = this.resolver.resolveComponentFactory(compType);
      return host.createComponent(factory, 0, injector);
    }
    return undefined;
  }
}
